import { Construction } from "lucide-react";

export default function AdminPlaceholder({ title }) {
  return (
    <section className="min-h-screen p-4 sm:p-6 lg:p-10">
      <div className="max-w-5xl">
        <div className="rounded-lg border border-white/10 bg-white/[0.03] p-6">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-md border border-[#2F6FA5]/30 bg-[#2F6FA5]/10 text-[#2F6FA5]">
              <Construction className="h-5 w-5" />
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#2F6FA5]">Admin</p>
              <h1 className="text-2xl font-bold text-white">{title}</h1>
            </div>
          </div>
          <p className="mt-4 text-sm text-slate-400">Coming soon.</p>
        </div>
      </div>
    </section>
  );
}
